import apiUrl from '../util/apiURL';

var Version = '2016-03-04';
var Region = window.KSC_SECNET_CONSOLE.ENV === 'prod' ? 'cn-beijing-6' : 'cn-qingyangtest-1';
var Service = 'common';

var commonUrls = {
    createProductCallback: '//network.' + KSC_SECNET_CONSOLE.BASE_HOST + '/v2/#/',
    // createProductVerify: '//ucenter.' + KSC_SECNET_CONSOLE.BASE_HOST + '/index.html#!/order/verify?'
    createProductVerify: '//uc.' + KSC_SECNET_CONSOLE.BASE_HOST + '/pro/buy/#/order/verify?'
};

export {
    commonUrls
};

export default {
    /**
     *  Action=getRegions,Service=network,type=?
        1：kvm；3：eip；
        6：slb；47：epc
     */
    CalculateProduct: apiUrl({
        Action: 'CalculateProduct',
        Service: 'eip',
        Version
    }),
    //判断是否出现UDP  接口200就出现
    DescribeQuotaSystemOfListenerUdp: apiUrl({
        Action: 'DescribeQuotaSystemOfListenerUdp',
        Service: 'slb',
        Version
    }),

    DescribePriceSystemOfIpv6Public: apiUrl({
        Action: 'DescribePriceSystemOfIpv6Public',
        // Service: 'price',
        Version
    }),

    GetRegionsOfAppSlb: apiUrl({
        Action: 'GetRegionsOfProduct',
        Service: 'price',
        Region,
        Version: '2016-03-04'
    }),

    GetRegions: apiUrl({
        Action: 'GetRegions',
        Service: 'price',
        // type: 3,
        Region,
        Version
    }),
    DescribePriceSystemOfEip: apiUrl({
        Action: 'DescribePriceSystemOfEip',
        Service: 'price',
        Region,
        Version
    }),
    DescribePriceSystemOfBws: apiUrl({
        Action: 'DescribePriceSystemOfBws',
        Service: 'price',
        Region,
        Version
    }),
    DescribePriceSystemOfSlb: apiUrl({
        Action: 'DescribePriceSystemOfSlb',
        Service: 'price',
        Region,
        Version
    }),

    DescribePriceSystem: apiUrl({
        Action: 'DescribePriceSystem',
        // Service: 'eip',
        Region,
        Version
    }),

    CheckUserConfig: apiUrl({
        Service: 'price',
        Action: 'CheckUserBwsPermission',
        Region,
        Version
    }),

    GetMonitorData: apiUrl({
        Service: 'network',
        Action: 'GetMonitorData',
        Version
    }),

    //判断是否接入试用转正
    GetFreeTrialWallet: apiUrl({
        Service: 'network',
        Action: 'GetFreeTrialWallet',
        Version
    }),

    //是否显示自定义线路
    getIsLine: apiUrl({
        Service: 'dns',
        Action: 'CheckDnsSeniorAuth',
        Version: '2016-06-07'
    }),
    GetCenUserPermission: apiUrl({
        Action: 'GetCenUserPermission',
        Service: 'cen',
        Version
    }),

    DescribeQuotaByName: apiUrl({
        Action: 'DescribeQuotaByName',
        Version,
        Service: 'network'
    }),
};
